<template>
  <div class="original-bill">
    <div class="header">
      <el-input class="query" v-model.trim="period" placeholder="请输入结算账期" clearable @keyup.native.enter="getBillList(1)" @clear="getBillList(1)"></el-input>
      <el-button type="primary" @click="getBillList(1)">查询</el-button>
    </div>
    <Table :data="billList" :columns="columns" :pages="pages"></Table>
  </div>
</template>
<script>
import BillService from "@/apis/BillService";
import Table from "@/components/new-table.vue";
export default {
  components: { Table },
  data() {
    return {
      period: "",
      billList: [],
      columns: [
        { label: "结算账期", prop: "settlementDate" },
        { label: "结算金额", prop: "merchantMoney", "min-width": "110px" },
        { label: "实付金额", prop: "payMoney" },
        { label: "服务费", prop: "serviceFee" },
        { label: "退款金额", prop: "refundMoney" },
        { label: "结算时间", prop: "settlementTime", "min-width": "150px" },
        {
          label: "操作", render: (h, { row }) => {
            return <el-button type="text" onClick={() => { this.openSettleDetail(row) }}>详情</el-button >
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
    }
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    getBillList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      BillService.getSettleList(page, pageSize, this.period).then(res => {
        this.billList = res.data.map(i => {
          i.serviceFee = (i.platformMoney + i.serviceCharge + i.refundFee).toFixed(2)
          return i
        });
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getBillList();
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getBillList();
    },
    openSettleDetail(row) {
      this.$router.push(`/settle-list?period=${row.settlementDate}`)
    },
  }
}
</script>

<style lang="scss" scoped>
.original-bill {
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 20px;
}
.query {
  width: 200px;
  margin-right: 20px;
  vertical-align: middle;
}
.state {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .state-dot {
    width: 5px;
    margin-right: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
</style>